// Shared location scope options used across admin engagement tab and event creation
const locationOptions = [
  "City",
  "Neighbourhood",
  "Metro Area",
  "Region",
  "State",
  "Country",
];

export default locationOptions;
